<template>
  <section>
    <!-- start of navbar design -->
    <div id="topBar">
      <router-link
        id="searchLogo"
        :to="{
          name: 'MessageBoard',
          params: {
            name: this.groupName.replace(/\s/g, '-'),
            id: this.groupId,
          },
        }"
        ><img
          src="@/assets/searchLogo.svg"
          class="mainPageLogo"
          alt="main page logo"
        />
      </router-link>

      <div style="display: flex; flex-direction: column; width: 100%">
        <input
          id="searchBar"
          list="searchContent"
          v-model="searchString"
          type="text"
          placeholder="Search CourseLnk"
          @focus="animate"
          @blur="deanimate"
          @keydown="checkTime($event)"
          autocomplete="off"
        />
        <div v-if="focused" id="searchDropDown" class="isWindow">
          <div v-if="loading" class="loaderContainer">
            <div class="loader"></div>
          </div>
          <div v-else>
            <template v-if="checkEmpty()">
              <div v-if="searchString.length === 0" class="emptyContainer">
                <img src="@/assets/Icons/StartSearchIcon.svg" />
                <b>Search for friends, courses, and groups!</b>
              </div>
              <div v-else class="emptyContainer">
                <img src="@/assets/Icons/EmptyIcon.svg" />
                <b>Oh no! We can't find what you're looking for</b>
              </div>
            </template>
            <ul
              class="searchContent"
              v-for="(object, index) in totalSearch"
              :key="index"
            >
              <template v-if="object.type == 'faculties'">
                <li
                  v-on:mousedown="
                    searchCourse(object.doc, object.id, object.type)
                  "
                  class="profileOption"
                >
                  <img
                    :src="object.doc.profileImage"
                    class="searchProfileImage"
                  />
                  {{ object.doc.name }}<br />
                  Faculty
                </li>
              </template>
              <template v-if="object.type == 'users'">
                <li
                  v-on:mousedown="
                    searchUser(
                      object.doc.firstName,
                      object.doc.lastName,
                      object.doc.nameCount
                    )
                  "
                  class="profileOption"
                >
                  <img
                    :src="object.doc.profileImage"
                    class="searchProfileImage"
                  />
                  <div class="textBox">
                    {{ object.doc.firstName }} {{ object.doc.lastName }}<br />
                    <p class="subText">User</p>
                  </div>
                </li>
              </template>
              <template v-if="object.type == 'campus'">
                <li
                  v-on:mousedown="
                    searchCourse(object.doc, object.id, object.type)
                  "
                  class="profileOption"
                >
                  <img
                    :src="object.doc.profileImage"
                    class="searchProfileImage"
                  />
                  {{ object.doc.name }}<br />
                  Campus Group
                </li>
              </template>
              <template v-if="object.type == 'global'">
                <li
                  v-on:mousedown="
                    searchCourse(object.doc, object.id, object.type)
                  "
                  class="profileOption"
                >
                  <img
                    :src="object.doc.profileImage"
                    class="searchProfileImage"
                  />
                  {{ object.doc.name }}<br />
                  Global Group
                </li>
              </template>
              <template v-if="object.type == 'courses'">
                <li
                  v-on:mousedown="
                    searchCourse(object.doc, object.id, object.type)
                  "
                  class="profileOption"
                >
                  <img
                    :src="object.doc.profileImage"
                    class="searchProfileImage"
                  />
                  {{ object.doc.name }}<br />
                  Course
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- end of navbar design -->
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import db from "@/db";
import firebase from "@/firebase";

//import router from "@/router/index";

export default {
  data: () => ({
    searchString: "",
    totalSearch: [],
    searchArray: [],
    searchUsers: [],
    searchCourses: [],
    searchGroups: [],
    searchFaculties: [],
    focused: false,
    hitNumber: 4,
    loading: false,
    doneTyping: false,
  }),

  components: {
    //PublicProfile
  },

  computed: {
    ...mapState("messageBoard", [
      "groupName",
      "searchingGroup",
      "groupPreview",
      "groupId",
    ]),
    ...mapState("mainPage", [
      "onMessageBoard",
      "onCalendar",
      "onReview",
      "onUpload",
    ]),
    ...mapState("user", ["user"]),
  },

  mounted() {},

  watch: {
    doneTyping() {
      if (this.doneTyping) {
        if (this.searchString.length != 0) {
          this.loading = true;
          var lowerString = this.searchString.toLowerCase();
          this.searchArray = lowerString.split(/(?:-| )+/);
          this.searchDatabase();
        } else {
          this.totalSearch;
        }
      }
    },
  },

  methods: {
    ...mapActions("user", ["logout"]),
    ...mapActions("messageBoard", ["setSearchGroup", "setGroupPreview"]),
    checkTime(event) {
      var keycode = event.keyCode;
      if (
        (keycode > 47 && keycode < 58) || // number keys
        keycode == 32 ||
        keycode == 8 ||
        keycode == 13 || // spacebar/backspace & return key(s) (if you want to allow carriage returns)
        (keycode > 64 && keycode < 91) || // letter keys
        (keycode > 95 && keycode < 112) || // numpad keys
        (keycode > 185 && keycode < 193) || // ;=,-./` (in order)
        (keycode > 218 && keycode < 223) // [\]' (in order)
      ) {
        this.doneTyping = false;
        setTimeout(() => {
          this.doneTyping = true;
        }, 800);
      } else {
        this.doneTyping = false;
      }
    },
    ambassadorInfo() {
      console.log("Clicked");
      db.collection("groups")
        .where("name", "==", "Ambassadors")
        .get()
        .then((docs) => {
          docs.forEach((doc) => {
            doc.data().users.forEach(async (user) => {
              var getUserFromUid = firebase
                .functions()
                .httpsCallable("getUserFromUid");
              const data = await getUserFromUid(user.user_id);
              db.collection("ambassadorInfo")
                .doc(user.user_id)
                .update({
                  referralCode: JSON.parse(JSON.stringify(data)).data.email,
                });
            });
          });
        });
    },
    /*updateUserDoc() {
      console.log("Clicked");
      db.collection("faculties")
        .orderBy("name", "asc")
        .get()
        .then((docs) => {
          docs.forEach((doc) => {
            db.collection("faculties")
              .doc(doc.id)
              .update({
                userCount: firebase.firestore.FieldValue.delete(),
                users: [],
              });
          });
        });
    },*/
    fixEmptyKeyword() {
      db.collection("courses")
        .where("numberKeywords", "==", "")
        .get()
        .then((docs) => {
          docs.forEach((doc) => {
            db.collection("courses")
              .doc(doc.id)
              .update({
                numberKeywords: [],
              });
          });
        });
    },
    fixSubjects() {
      console.log("Success");
      db.collection("subjects")
        .get()
        .then((docs) => {
          docs.forEach((doc) => {
            var subject = doc.data();
            db.collection("schools")
              .doc(subject.school_id)
              .update({
                subjects: firebase.firestore.FieldValue.arrayUnion(
                  subject.name
                ),
              });
          });
        });
    },

    addInfo() {
      console.log("Success");
      db.collection("users")
        .get()
        .then((docs) => {
          docs.forEach((doc) => {
            if (
              doc.id !== "7Ub5bzzb1JNC1sjW0RMywcoNftr2" &&
              doc.data().firstName !== "Nick"
            ) {
              db.collection("users")
                .doc(doc.id)
                .update({
                  courses: [],
                  faculties: [],
                  groups: [],
                  directMessages: [],
                  clips: [],
                });
            }
          });
        });
    },
    async searchDatabase() {
      //console.log("searched");
      var totalSearch = [];
      // Search Faculties
      if (!/\d/.test(this.searchString)) {
        await db
          .collection("faculties")
          .where("school_id", "==", this.user.school_id)
          .where("keywords", "array-contains-any", this.searchArray)
          .limit(2)
          .get()
          .then((docs) => {
            docs.forEach((doc) => {
              let data = {
                doc: doc.data(),
                searchResult: doc.data().name,
                type: "faculties",
                id: doc.id,
              };
              totalSearch.push(data);
            });
          });
      }
      // Search Users
      if (!/\d/.test(this.searchString)) {
        await db
          .collection("users")
          .where("firstNameKeywords", "array-contains", this.searchArray[0])
          .limit(20)
          .get()
          .then((docs) => {
            docs.forEach((doc) => {
              let data = {
                doc: doc.data(),
                id: doc.id,
                searchResult: doc.data().firstName + " " + doc.data().lastName,
                type: "users",
              };
              totalSearch.push(data);
            });
          });
        await db
          .collection("users")
          .where("lastNameKeywords", "array-contains-any", this.searchArray)
          .limit(20)
          .get()
          .then((docs) => {
            docs.forEach((doc) => {
              if (totalSearch.findIndex((x) => x.id == doc.id) == -1) {
                let data = {
                  doc: doc.data(),
                  searchResult: doc.data().lastName,
                  type: "users",
                };
                totalSearch.push(data);
              }
            });
          });
      }
      // Search Groups
      await db
        .collection("groups")
        .where("school_id", "==", this.user.school_id)
        .where("keywords", "array-contains-any", this.searchArray)
        .where("privacyType", "!=", "secret")
        .limit(10)
        .get()
        .then((docs) => {
          docs.forEach((doc) => {
            let data = {
              doc: doc.data(),
              searchResult: doc.data().name,
              type: "campus",
              id: doc.id,
            };
            totalSearch.push(data);
          });
        });
      await db
        .collection("groups")
        .where("isGlobal", "==", true)
        .where("keywords", "array-contains-any", this.searchArray)
        .where("privacyType", "!=", "secret")
        .limit(10)
        .get()
        .then((docs) => {
          docs.forEach((doc) => {
            let data = {
              doc: doc.data(),
              searchResult: doc.data().name,
              type: "global",
              id: doc.id,
            };
            totalSearch.push(data);
          });
        });

      // Search Courses
      if (this.searchArray.length > 1) {
        await db
          .collection("courses")
          .where("school_id", "==", this.user.school_id)
          .where(
            "letterKeywords",
            "array-contains",
            this.searchString.toLowerCase()
          )
          .limit(10)
          .get()
          .then((docs) => {
            docs.forEach((doc) => {
              let data = {
                doc: doc.data(),
                id: doc.id,
                searchResult: doc.data().name,
                type: "courses",
              };
              totalSearch.push(data);
            });
          });
        await db
          .collection("courses")
          .where("school_id", "==", this.user.school_id)
          .where("letterKeywords", "array-contains-any", this.searchArray)
          .limit(10)
          .get()
          .then((docs) => {
            docs.forEach((doc) => {
              if (totalSearch.findIndex((x) => x.id == doc.id) == -1) {
                let data = {
                  doc: doc.data(),
                  searchResult: doc.data().name,
                  type: "courses",
                  id: doc.id,
                };
                totalSearch.push(data);
              }
            });
          });
      } else {
        await db
          .collection("courses")
          .where("school_id", "==", this.user.school_id)
          .where("letterKeywords", "array-contains-any", this.searchArray)
          .limit(10)
          .get()
          .then((docs) => {
            docs.forEach((doc) => {
              let data = {
                doc: doc.data(),
                searchResult: doc.data().name,
                type: "courses",
                id: doc.id,
              };
              totalSearch.push(data);
            });
          });
        await db
          .collection("courses")
          .where("school_id", "==", this.user.school_id)
          .where("numberKeywords", "array-contains-any", this.searchArray)
          .limit(10)
          .get()
          .then((docs) => {
            docs.forEach((doc) => {
              let data = {
                doc: doc.data(),
                searchResult: doc.data().numberKeywords[
                  doc.data().numberKeywords.length - 1
                ],
                type: "courses",
                id: doc.id,
              };
              totalSearch.push(data);
            });
          });
      }

      // Sort search based on relevency
      var sortedSearch = [];
      for (var option = 0; option < totalSearch.length; option++) {
        let relevency = this.commonChars(
          totalSearch[option].searchResult,
          this.searchString
        );
        totalSearch[option].relevency = relevency / this.searchString.length;
        //if (relevency / this.searchString.length > 0.4) {
        sortedSearch.push(totalSearch[option]);
        //}
      }
      sortedSearch.sort((a, b) => b.relevency - a.relevency);
      console.log(sortedSearch);
      this.loading = false;
      this.doneTyping = false;
      this.totalSearch = sortedSearch.slice(0, 8);
    },

    commonChars(s1, s2) {
      s1 = s1.toLowerCase();
      s2 = s2.toLowerCase();
      s1 = s1.split(" ");
      s2 = s2.split(" ");
      let seenChars = [];
      let shortStr;
      let longStr;
      let counter = 0;

      if (s1.length < s2.length) {
        shortStr = s1;
        longStr = s2;
      } else {
        shortStr = s2;
        longStr = s1;
      }

      for (let i = 0; i < shortStr.length; i++) {
        var shortWord;
        var longWord;
        if (shortStr[i].length < longStr[i].length) {
          shortWord = shortStr[i];
          longWord = longStr[i];
        } else {
          shortWord = longStr[i];
          longWord = shortStr[i];
        }
        for (let j = 0; j < shortWord.length; j++) {
          if (
            longWord.indexOf(shortWord[j]) !== -1 &&
            !seenChars.includes(shortWord[j])
          ) {
            counter++;
            seenChars.push(shortWord[j]);
          }
        }
      }
      return counter;
    },

    searchUser(firstName, lastName, nameCount) {
      let userName = "";
      if (nameCount) {
        userName = firstName + "-" + lastName + "-" + nameCount;
      } else {
        userName = firstName + "-" + lastName;
      }
      this.$router.replace({
        name: "PublicProfile",
        params: { userName: userName },
      });
    },
    searchCourse(course, id, type) {
      if (this.user.allGroups.findIndex((x) => x.id === id) != -1) {
        var name = course.name.replace(" ", "-");
        this.$router.replace({
          name: "MessageBoard",
          params: { name: name, id: id, type: type },
        });
        this.$router.go();
      } else {
        if (type == "global" || type == "campus") {
          type = "groups";
        }
        db.collection(type)
          .doc(id)
          .get()
          .then((doc) => {
            var previewCourse = doc.data();
            previewCourse.type = type;
            previewCourse.id = id;
            this.$store.commit("messageBoard/setGroupPreview", previewCourse);
            this.$store.commit("messageBoard/setSearchGroup", true);
          });
      }
    },
    animate() {
      this.focused = true;
      document.getElementById("searchLogo").style.transform =
        "translateX(-65px)";
      document.getElementById("searchBar").style.transform =
        "translateX(-65px)";
    },
    deanimate() {
      this.focused = false;
      document.getElementById("searchLogo").style.transform = "translateX(0)";
      document.getElementById("searchBar").style.transform = "translateX(0)";
    },
    async getName() {
      var name = await this.groupName;
      return name.replace(/\s/g, "");
    },
    checkEmpty() {
      return this.focused && !this.totalSearch.length;
    },
  },
};
</script>

<style src="@/styles/Navbar.css"></style>
